const $ = require("jquery");
const _template = require("lodash/template");

let HasGoogleApiBeenRequested = false;
let IsGoogleApiInitialized = false;
let Callbacks = new Array();
const DefaultInactivePinUrl = "/-/media/foundation/map-images/mappinstandard.svg";
const DefaultActivePinUrl = "/-/media/foundation/map-images/mappinwsl.svg";
const UserLocationPinUrl = "/-/media/foundation/map-images/mapcurrentlocation.png";
let DefaultWsMapOptions;
const DefaultActivePinWidth = 74;
const DefaultActivePinHeight = 96;
const DefaultInactivePinWidth = 34;
const DefaultInactivePinHeight = 44;

const DefaultGoogleMapOptions = {
    mapId: "a400c87f2b2361452f8d9a46",
    fullscreenControl: false,
    mapTypeControl: false,
    rotateControl: false,
    scaleControl: false,
    streetViewControl: false,
    useLetterMarkers: false,
    zoom: 16,
    zoomControl: true
};

function wsMap(element, userLocation, locations, options) {
    let markers = new Array();
    let infoWindows = new Array();
    let map = new google.maps.Map(element, DefaultGoogleMapOptions);
    let bounds = new google.maps.LatLngBounds();
    let templateFn;

    options = options || {};
    options = $.extend({}, DefaultWsMapOptions, options);
    MapOptions = options;

    templateFn = _template(options.infoWindowTemplate);

    const activeMarkerImg = document.createElement("img");
    activeMarkerImg.src = options.activeMapPin?.url || DefaultActivePinUrl;
    activeMarkerImg.style.width = `${options.activeMapPin?.width || DefaultActivePinWidth}px`;
    activeMarkerImg.style.height = `${options.activeMapPin?.height || DefaultActivePinHeight}px`;
    activeMarkerImg.role = "presentation";

    function createInactiveMarkerContent(label) {
        // Create a wrapper div
        const content = document.createElement("div");
        content.style.position = "relative";
        content.style.display = "inline-block";

        // Create the marker image
        const inactiveMarkerImg = document.createElement("img");
        inactiveMarkerImg.src = options.inactiveMapPin?.url || DefaultInactivePinUrl;
        inactiveMarkerImg.style.width = `${options.inactiveMapPin?.width || DefaultInactivePinWidth}px`;
        inactiveMarkerImg.style.height = `${options.inactiveMapPin?.height || DefaultInactivePinHeight}px`;
        inactiveMarkerImg.style.display = "block";
        inactiveMarkerImg.role = "presentation";

        // Add the image to the wrapper
        content.appendChild(inactiveMarkerImg);

        // If a label is provided, add it
        if (label !== undefined && label !== null) {
            const labelDiv = document.createElement("div");
            labelDiv.textContent = options.useLetterMarkers
                ? String.fromCharCode(label + 65) // A, B, C...
                : (label + 1).toString();         // 1, 2, 3...

            // Style the label as needed
            labelDiv.style.position = "absolute";
            labelDiv.style.top = "8px";
            labelDiv.style.left = "50%";
            labelDiv.style.transform = "translateX(-50%)";
            labelDiv.style.color = "white";
            labelDiv.style.fontWeight = "bold";
            labelDiv.style.fontSize = "14px";
            labelDiv.style.pointerEvents = "none";
            labelDiv.style.textShadow = "0 0 2px #000";

            content.appendChild(labelDiv);
        }

        return content;
    }

    if (userLocation) {
        const userMarkerImg = document.createElement("img");
        userMarkerImg.src = UserLocationPinUrl;
        userMarkerImg.style.width = "25px";
        userMarkerImg.style.height = "25px";
        userMarkerImg.role = "presentation";

        const userMarker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: { lat: userLocation.latitude, lng: userLocation.longitude },
            content: userMarkerImg,
            zIndex: google.maps.Marker.MAX_ZINDEX + 2
        });

        bounds.extend(userMarker.position);
    }

    for (let i = 0; i < locations.length; ++i) {

        let inactiveMarkerContent = options.showMarkerLabels
            ? createInactiveMarkerContent(i)
            : createInactiveMarkerContent();

        let marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: { lat: locations[i].latitude, lng: locations[i].longitude },
            content: activeMarkerImg,
            title: locations[i].name // Office
                || locations[i].fullName // Agent
                || "Unknown Location"
        });

        marker.element.addEventListener("focus", () => {
            marker.element.style.outline = "2px dotted #0072BC";
            marker.element.style.outlineOffset = "5px";
            marker.element.style.borderRadius = "5px";
        });

        marker.element.addEventListener("blur", () => {
            marker.element.style.outline = "";
        });

        marker.inactiveMarkerContent = inactiveMarkerContent; // store so the content can be restored if it becomes active and then inactive again

        if (options.showInfoWindows) {
            let infoWindow = new google.maps.InfoWindow({
                content: templateFn(locations[i])
            });

            google.maps.event.addListener(marker, "click", function () {
                infoWindows.forEach(wind => wind.close());
                infoWindow.open(map, marker);
            });

            infoWindows.push(infoWindow);
        }

        google.maps.event.addListener(marker, "click", function () {
            markers.forEach(setInactiveMarker);
            setActiveMarker(marker);
        });

        markers.push(marker);
        bounds.extend(marker.position);
    }

    resetCenterAndZoom();

    function resetCenterAndZoom() {
        if (markers.length === 1) {
            map.setCenter(markers[0].position);
            map.setZoom(DefaultGoogleMapOptions.zoom);
        } else {
            map.fitBounds(bounds);
        }
    }

    function setActiveMarker(marker) {
        if (!marker) {
            return;
        }

        markers.forEach(setInactiveMarker);
        marker.content = activeMarkerImg;
        marker.zIndex = google.maps.Marker.MAX_ZINDEX + 1
    }

    function setInactiveMarker(marker) {
        marker.content = marker.inactiveMarkerContent;
        marker.zIndex = google.maps.Marker.MAX_ZINDEX
    }

    return {
        map: map,
        markers: markers,
        infoWindows: infoWindows,
        resetCenterAndZoom: resetCenterAndZoom,
        setActiveMarker: setActiveMarker
    };
}

exports.WsMap = wsMap;

exports.registerCallback = function (callback) {
    if (!$.isFunction(callback)) {
        return;
    }

    if (IsGoogleApiInitialized) {
        callback();
    } else {
        Callbacks.push(callback);

        if (!HasGoogleApiBeenRequested) {
            $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCvlf6ooDCv3CvfvyjnWWrTEJpdskTrKwg&callback=WS.initMap&libraries=marker&v=quarterly&loading=async&map_ids="a400c87f2b2361452f8d9a46"');
            HasGoogleApiBeenRequested = true;
        }
    }
};

window.WS.initMap = function () {
    IsGoogleApiInitialized = true;

    DefaultWsMapOptions = {
        showMarkerLabels: true,
        showInfoWindows: true,
        infoWindowTemplate: '<div class="ws-map__info-window"><p class="ws-paragraph"><%- streetAddress %><br /><%- city %>, <%- state %> <%- zipCode %><br /><%- formattedPhoneNumber %><br /><i class="fa-solid fa-location-dot ws-color-primary"></i> <a href="<%- directionsUrl %>" target="_blank">Directions</a></p></div>'
    };

    for (let i = 0; i < Callbacks.length; ++i) {
        Callbacks[i]();
    }
};